import { createReducer } from "typesafe-actions";

import Legend from "@app/enum/map/Legend";
import { Actions as AppActions, initializeApp } from "@app/store/app/actions";
import LegendState from "@app/types/map/LegendState";

import { MapLegendsActions, toggleLegendExpandedState, toggleLegendVisibility } from "./actions";

export interface LegendsState extends Partial<Record<Legend, LegendState>> {}

export const legendsInitialState: LegendsState = {
  [Legend.COLOR_KEY]: { expanded: true, visible: true },
  [Legend.SHAPE_KEY]: { expanded: true, visible: true },
};

const mapLegends = createReducer<LegendsState, AppActions | MapLegendsActions>(legendsInitialState)
  .handleAction(initializeApp.success, (state, { payload }) => ({
    ...state,
    ...((payload.metaData?.legendsSettings as LegendsState | undefined) ?? {}),
  }))
  .handleAction(toggleLegendVisibility, (state, { payload }) => ({
    ...state,
    [payload.name]: { ...state[payload.name], visible: payload.visible },
  }))
  .handleAction(toggleLegendExpandedState, (state, { payload }) => ({
    ...state,
    [payload.name]: { ...state[payload.name], expanded: payload.expanded },
  }));

export default mapLegends;
